module.exports = __webpack_public_path__ + "img/icon_before_hover.b975f833.svg";